import { render } from "./AddVuniversityModal.vue?vue&type=template&id=9d040120&scoped=true"
import script from "./AddVuniversityModal.vue?vue&type=script&lang=js"
export * from "./AddVuniversityModal.vue?vue&type=script&lang=js"

import "./AddVuniversityModal.vue?vue&type=style&index=0&id=9d040120&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\versatech_vex\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d040120"]])

export default __exports__